import React from 'react'
import '../../styles/components/Spinner.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCroissant } from '@fortawesome/pro-solid-svg-icons'

interface SpinnerProps {
  text?: string
}

const Spinner: React.FC<SpinnerProps> = ({ text = 'Loading...' }) => {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="spinner__icon">
          <FontAwesomeIcon icon={faCroissant} />
        </div>
        <div className="spinner__text">{text}</div>
      </div>
    </div>
  )
}

export default Spinner
